import * as React from 'react';

/**
 * Gets only valid React Element children.
 * Filter nullish or falsy children.
 */
export function getElementChildren(children) {
  // $FlowFixMe[underconstrained-implicit-instantiation]: $NonMaybeType<React.Node> not possible.
  return React.Children.toArray(children).filter(React.isValidElement);
}